import React, { useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider,  Stack, TextField, Typography } from '@mui/material'
import { Item } from '../../../../common/snippets'
import SearchLocationInput from '../../../BookingActivity/SearchLocationInput'
import GpsFixedIcon from '@mui/icons-material/GpsFixed'
import { RadioItem } from '../../../../helpers/radioItem'
import LineInputV2 from '../../../../common/lineinputV2'
import { navigation1, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import * as iid from '../../../../common/bookingElementId'
import { useTranslation } from '../../../../../i18n/I18nProvider'
const MapLocation = (props) => {
    const { updateModal, headText, recentAddressList, savedAddressList, setAddress, address, getcurrentLocation, saveAction, isDeliver, originLatLong } = props
    const [howtoreach, setHowtoReach] = useState(address?.howToReach || '')
    const [saveAddress, setSaveAddress] = useState(true)
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

    }
    const saveAddressData = () => {
        if (address?.formatted_address) {
            updateModal()
            if (saveAddress) {
                saveAction()
            }
        }
    }
    return (
        <Modal
            headTxt={headText}
            width={'80%'}
            updateModal={updateModal}
            modalStyle={modalStyle}
            modalClass={'booking-popup'}
            closeId={"closeButton"}
        >
            <Stack
                direction="row"
                divider={
                    <Divider
                        orientation="vertical"
                        sx={{
                            width: '2px',
                            margin: '14px -16px 0px 0px !important',
                        }}
                        flexItem
                    />
                }
                spacing={2}
                sx={{ background: '#FFF' }}
                className="pickup-ov"
            >
                <Box className="pickup-ov-left">
                    <Item>
                        <div className={'input--wrapper'} style={{ width: '100%' }}>
                            <SearchLocationInput onChange={() => null} setAddress={setAddress} isDeliver={isDeliver} originLatLong={originLatLong} />
                        </div>
                        <Box className="gps-button">
                            <Button startIcon={<GpsFixedIcon />} 
                            // onClick={getcurrentLocation}
                                sx={{
                                    'svg': {
                                        color: '#0086FF !important'
                                    }
                                }}
                            >
                                {tr('getCurrentLocation', 'Get Current Location')}
                            </Button>
                            {tr('usingGps', '(Using GPS)')}
                        </Box>

                    </Item>

                    {recentAddressList.length ? (
                        <>
                            <Divider sx={{ flexGrow: 1, borderWidth: '1px', marginRight: '0px' }}></Divider>
                            <Item>
                                <Box className="bold dark">{tr('recentSearches', 'Recent Searches')}</Box>
                                <Box className="scroll">
                                    {removeDuplicatesFromArray(recentAddressList, 'formatted_address').map((el, index) => (
                                        <RadioItem
                                            key={'item1211' + index}
                                            value={el}
                                            selected={address}
                                            texthead={el.name}
                                            textbody={el.formatted_address}
                                            onChange={setAddress}
                                        />
                                    ))}
                                </Box>
                            </Item>
                        </>
                    ) : ''}
                    {savedAddressList?.length ? (
                        <>
                            <Divider sx={{ flexGrow: 1, borderWidth: '1px', marginRight: '0px' }}></Divider>
                            <Item>
                                <Box className="bold dark">{tr('savedAddress', 'Saved Address')}</Box>
                                <Box className="scroll">
                                    {savedAddressList.map((el, index) => (
                                        <RadioItem
                                            key={'item1211' + index}
                                            value={el}
                                            selected={address}
                                            texthead={el.name}
                                            textbody={el.formatted_address}
                                            onChange={setAddress}
                                        />
                                    ))}
                                </Box>
                            </Item>
                        </>
                    ) : ''}
                </Box>
                <Box className="pickup-ov-right">
                    {address.formatted_address && (
                        <Item className="flex">
                            <Stack direction="row" className="selected-address">
                                <Box className="selected-address-data">
                                    {address?.contact && <Typography className="bold"> {`${address?.isd} ${address?.contact}`}</Typography>}
                                    <Typography>{address?.formatted_address}</Typography>
                                </Box>
                            </Stack>
                        </Item>
                    )}

                    <Item className="flex">
                        <div className={'input--wrapper'} style={{ width: '100%', marginRight: '10px', marginBottom: 0 }}>
                            <LineInputV2
                                id={iid.houseNo}
                                label={tr('houseFlatNo', 'House / Flat No.')}
                                type="text"
                                name={'address-area'}
                                value={address?.flatNo || ''}
                                sx={{ margin: '8px', width: '100%' }}
                                onBlur={(e) => {
                                    setAddress({ ...address, flatNo: e.target.value })
                                }}
                                onKeyDown={(e) => navigation3(e, iid.apartment, iid.gmapInputId, () => { })}
                            />
                        </div>
                        <div className={'input--wrapper'} style={{ width: '100%', marginBottom: 0 }}>
                            <LineInputV2
                                id={iid.apartment}
                                label={tr('apartmentBuildingName', 'Apartment / Building Name  ')}
                                type="text"
                                name={'address-area'}
                                value={address?.building || ''}
                                sx={{ margin: '8px', width: '100%' }}
                                onBlur={(e) => {
                                    setAddress({ ...address, building: e.target.value })
                                }}
                                onKeyDown={(e) => navigation1(e, iid.howToReach, iid.houseNo)}
                            />
                        </div>
                    </Item>
                    <Item className="textarea">
                        <TextField
                            id={iid.howToReach}
                            className="how-to-reach"
                            label={tr('howToReachOptional', 'How to Reach (Optional)')}
                            multiline
                            rows={4}
                            value={howtoreach}
                            onChange={(e) => setHowtoReach(e.target.value)}
                            onKeyDown={(e) => {
                                navigation3(e, 'saveAddressBtn', iid.apartment, () => { })
                            }}
                            onBlur={(e) => {
                                setAddress({ ...address, howToReach: howtoreach })
                            }}
                        />
                    </Item>
                    <Divider sx={{ flexGrow: 1, borderWidth: '1px', marginRight: '0px' }}></Divider>
                    <Box component="div" className="modal-btn-grp confirm-poup-grp">
                        <Button id='saveAddressBtn' className="btn btn-primary margin-normal" 
                        onClick={() => {
                            saveAddressData()
                        }}
                            onKeyDown={(e) => {
                                navigation3(e, iid.houseNo, iid.howToReach, () => {
                                })
                            }}
                        >
                            {tr('saveAddress', 'Save Address')}
                        </Button>
                    </Box>
                </Box>
            </Stack>
        </Modal>
    )
}
export default MapLocation
